import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { TcV2LoyaltyProgramsListItemDesktopComponent } from '@features/transfer-connect-v2/components/loyalty-programs-list-item-desktop/loyalty-programs-list-item-desktop.component';
import { TransferConnectV2SettingService } from '@features/transfer-connect-v2/services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';
import { TranslateService } from '@ngx-translate/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { NumberService } from '@rd/core/services/number/number.service';
import { LoyaltyProgramHelper } from '@rd/helpers/loyalty-program.helper';

@Component({
  selector: 'rd-anz-tcv2-loyalty-programs-list-item-desktop',
  templateUrl: './loyalty-programs-list-item-desktop.component.html',
  styleUrls: ['./loyalty-programs-list-item-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnzTcV2LoyaltyProgramsListItemDesktopComponent extends TcV2LoyaltyProgramsListItemDesktopComponent {
  @HostBinding('class.rd-anz-tcv2-loyalty-programs-list-item-desktop')
  componentClass = true;

  hoverTile = false;

  constructor(
    loyaltyProgramHelper: LoyaltyProgramHelper,
    numberService: NumberService,
    translateService: TranslateService,
    iconRegistryService: IconRegistryService,
    transferConnectV2SettingService: TransferConnectV2SettingService,
    private router: Router,
  ) {
    super(
      loyaltyProgramHelper,
      numberService,
      translateService,
      iconRegistryService,
      transferConnectV2SettingService,
    );
  }

  redirectToCheckout(): void {
    this.router.navigate([this.checkoutUrl()]);
  }
}
